/* eslint-disabe react/prop-types */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// forms and validation
import * as Yup from "yup";
import { useFormik } from "formik";
// components
import _Input from "../../generic/_Input";
import _Button from "../../generic/_Button";
// bootstrap
import Modal from "react-bootstrap/Modal";
// data fetching
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint, ApiSMSEndpoint } from "../../../utils/ApiEndpoint";
// auth
import { useAuth } from "../../../Context/AuthContext";
// utils
import { ErrorMessage, SuccessMessage } from "../../../utils/toastify";
import { EncryptData } from "../../../utils/Encrypt";
import { errorLabels } from "../../../utils/helpers";
const _ModalTestSMS = (props) => {
  const auth = useAuth();
  const { token, uid_user } = auth.getSessionData();
  const { visible, onClose, title, data } = props;
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      message: "",
      msisdn: "",
      apiDetail: {},
    },
    validateOnMount: false,
    validationSchema: Yup.object({
      message: Yup.string()
        .min(3, "El mensaje debe tener al menos 3 caracteres")
        .max(399, "El mensaje no puede tener más de 399 caracteres")
        .required("El mensaje es requerido"),
      msisdn: Yup.string()
        .matches(
          /^(?:\d{10}|[*#]\d{2,5})$/,
          "Debe ser un número de 10 dígitos o un número corto que empiece con * o #"
        )
        .required("El número es requerido"),
    }),
    onSubmit: async (values) => {
      await onAction(values);
    },
  });

  const { refetch } = useQuery({
    queryKey: ["partner", uid_user],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}administration/partnerdetail/${props.data.uid_partner}`,
        {},
        token
      );
      formik.setFieldValue("apiDetail", response.data, false);
      return null;
    },
    enabled: false,
  });

  useEffect(() => {
    if (visible && data) {
      refetch();
    }
  }, [visible, data]);

  const onValidate = async () => {
    setLoading(true);
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onAction = async (data = {}) => {
    const { apiDetail, msisdn, message } = data;

    const currentTime = new Date().getTime();

    const hash_data = EncryptData(
      apiDetail?.vc_partnerid + currentTime + apiDetail?.vc_secretkey
    );

    const data_to_submit = {
      security: {
        partner_id: apiDetail?.vc_partnerid,
        time: currentTime,
        hash: hash_data,
      },
      notify: {
        service_id: apiDetail?.vc_serviceid,
        number: msisdn,
        carrier: props.data.id_carrier,
        message: message,
        mask: props.data.vc_mask,
        xtraparams: {
          panelUserId: uid_user,
          source: "Panel",
        },
      },
    };

    const headers = {
      "Content-Type": "application/json",
    };

    const res = await httpClient(
      "POST",
      ApiSMSEndpoint,
      data_to_submit,
      null,
      headers
    );

    if (res.data.result.code !== "0") {
      throw new Error(res.data.result.message);
    }

    SuccessMessage("Se ha enviado el SMS con éxito");

    _onClose();
  };

  // const userLimit = async () => {
  //   const response = await httpClient(
  //     "POST",
  //     `${ApiEndpoint}users/userlimitsms`,
  //     {
  //       uid_user: uid_user,
  //     },
  //     token
  //   );

  //   if (
  //     response.data.i_limit > 0 &&
  //     response.data.i_currentsms + 1 > response.data.i_limit
  //   ) {
  //     throw new Error(
  //       "Ha alcanzado el límite de envío de SMS para su usuario."
  //     );
  //   }
  // };

  const _onClose = () => {
    if (onClose) onClose();

    formik.resetForm();
  };
  return (
    <Modal show={visible} onHide={_onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-md text-gray-600 flex justify-start gap-2">
          Máscara:{" "}
          <div className="text-gray-700 font-bold">
            {props.data?.vc_mask ?? "----"}
          </div>
        </div>

        <_Input
          required
          title="Número de teléfono"
          value={formik.values.msisdn}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          name="msisdn"
          id="msisdn"
          placeholder="Ingrese el número de teléfono"
          isError={formik.errors && formik.touched && formik.errors.msisdn}
          errors={formik.errors && formik.touched ? formik?.errors.msisdn : ""}
        />

        <_Input
          required
          alias={"textarea"}
          rows={5}
          title="Mensaje SMS"
          value={formik.values.message}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          name="message"
          id="message"
          placeholder="Mensaje"
          isError={formik.errors && formik.touched && formik.errors.message}
          errors={formik.errors && formik.touched ? formik?.errors.message : ""}
        />
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cancelar"
          style="none"
          onClick={_onClose}
          loading={loading}
          disabled={loading}
        />

        <_Button
          title="Enviar SMS"
          onClick={onValidate}
          style="primary"
          loading={loading}
          disabled={loading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalTestSMS.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  _onAction: PropTypes.func,
  title: PropTypes.string,
};

export default _ModalTestSMS;
